import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Form, Modal } from 'antd';

import { useDefaultFormErrorNotification } from '@/hooks';

import { ModalProps } from '@/types/ModalProps';
import InventoryForm from '../../InventoryForm';
import {
  CreateInventoryRequest,
  InventoryFormValues,
} from '@/core/domain/inventory/inventories/Inventory.types';
import { useCreateInventory } from '@/core/domain/inventory/inventories/inventory.hooks';

function CreateInventoryModal({ visible, handleVisible }: ModalProps) {
  const intl = useIntl();
  const history = useHistory();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const [form] = Form.useForm<InventoryFormValues>();

  const mutation = useCreateInventory();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const obj: CreateInventoryRequest = {
        ...values,
        date: values.date.format('YYYY-MM-DD'),
      };

      const result = await mutation.mutateAsync(obj);

      history.push(`/app/movements/inventory/${result.id}`);
      handleVisible();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'inventory.create' })}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={992}
      confirmLoading={mutation.isLoading}
    >
      <InventoryForm form={form} />
    </Modal>
  );
}

export default CreateInventoryModal;
